import { __extends } from "tslib";
import MultipleMaskBase from './base';
import { getMaskAttrs, getMaskPath } from '../path';
/**
 * @ignore
 * 多个点构成的 Path 辅助框 Action
 */
var PathMultiMask = /** @class */ (function (_super) {
    __extends(PathMultiMask, _super);
    function PathMultiMask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getMaskPath = getMaskPath;
        _this.getMaskAttrs = getMaskAttrs;
        return _this;
    }
    PathMultiMask.prototype.addPoint = function () {
        this.resize();
    };
    return PathMultiMask;
}(MultipleMaskBase));
export default PathMultiMask;
//# sourceMappingURL=path.js.map